import React from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router';
import { convertForms } from 'utils/selectConversions';
import FormikSelect from 'catalyst/core/form/Select/variants/FormikSelect';
import Button from 'catalyst/core/Button';
import api from 'api';

const validationSchema = {};

const AddToGroupForm = ({ addtoGroupList, forms }) => {
    const { id: groupId } = useParams();

    const addResourceToGroup = (resource_id) => {
        const resource = {
            type: 'forms',
            resource_id,
        };
        api.groups
            .addResource(groupId, resource)
            .then((result) => {
                addtoGroupList(result);
                console.log(result);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <Formik
            initialValues={[]}
            onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                console.log(values);
                addResourceToGroup(values.formId);
            }}
            validationSchema={yup.object(validationSchema)}
        >
            {({ submitForm, isSubmitting, errors, touched, values }) => {
                const submit = (event) => {
                    event.preventDefault();
                    submitForm();
                };
                return (
                    <Grid style={{ padding: '15px' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-end"
                            spacing={1}
                        >
                            <Grid item xs={8}>
                                <FormikSelect
                                    id={'formId'}
                                    label={'Custom Forms'}
                                    name={'formId'}
                                    items={convertForms(forms)}
                                    style={{ minWidth: '180px' }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={4} style={{ paddingBottom: '13px' }}>
                                <Button
                                    onClick={submit}
                                    color={'primary'}
                                    variant={'contained'}
                                    fullWidth
                                >
                                    Add Form to Group
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                );
            }}
        </Formik>
    );
};

export default AddToGroupForm;
